
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magnets-cto",
      function () {
        return require("private-next-pages/magnets-cto.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/magnets-cto"])
      });
    }
  